<div class="card card-xs">
  <div class="card-body">
    <span class="icon me-2">
      <fa class="{{icon}}"></fa>
  </span>
  <ng-content></ng-content>
  </div>
</div>